import {RecordKind} from 'core/Record';

enum ObsoleteRecordKind {
  Spend = 0,
  Income = 1,
  Refill = 2,
}

type ObsoleteRecord = {
  type: ObsoleteRecordKind;
  amount: MoneyAmount;
  dateTime: UnixTimeStamp;
};

type ObsoleteHistory = List<ObsoleteRecord>;
type ActualHistory = HistoryLog;

function convertRecordKind(type: ObsoleteRecordKind): RecordEntryKind {
  switch (type.toString()) {
    case String(ObsoleteRecordKind.Spend):
      return RecordKind.Spend;
    case String(ObsoleteRecordKind.Income):
      return RecordKind.Income;
    case String(ObsoleteRecordKind.Refill):
      return RecordKind.Refill;
    default:
      return type as unknown as RecordEntryKind;
  }
}

export function upgradeRecordKind(state: ObsoleteHistory): ActualHistory {
  return state.map((record) => ({...record, type: convertRecordKind(record.type)}));
}
